import React from 'react';
import { createRoot } from 'react-dom/client';
import { getMissingEnv } from './config/runtimeConfig';

if (process.env.NODE_ENV === 'development') {
  const shouldHideReactBeautifulDndDefaultPropsWarning = (args) => {
    const message = args.map((arg) => String(arg)).join(' ');
    return (
      message.includes('Connect(Droppable)') &&
      message.includes('Support for defaultProps will be removed from memo components')
    );
  };

  const originalConsoleError = console.error;
  console.error = (...args) => {
    if (shouldHideReactBeautifulDndDefaultPropsWarning(args)) return;
    originalConsoleError(...args);
  };

  const originalConsoleWarn = console.warn;
  console.warn = (...args) => {
    if (shouldHideReactBeautifulDndDefaultPropsWarning(args)) return;
    originalConsoleWarn(...args);
  };
}

const container = document.getElementById('root');
const root = createRoot(container);
const missingEnv = getMissingEnv();

if (missingEnv.length > 0) {
  console.error('Missing runtime config (env-config.js):', missingEnv);
  root.render(
    <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
      <h2>Missing runtime configuration</h2>
      <p>Set these environment variables on the container and restart it:</p>
      <ul>
        {missingEnv.map((name) => (
          <li key={name}>
            <code>{name}</code>
          </li>
        ))}
      </ul>
    </div>
  );
} else {
  import('./App').then(({ default: App }) => root.render(<App />));
}
